import type { ScoringRules, UserAnswer, Question } from '@examflow/core';

/**
 * IELTS 评分规则
 * IELTS 使用 0-9 分制（Band Score）
 */
export const ieltsScoringRules: ScoringRules = {
  totalScore: 9, // 最高 9 分
  passingScore: 6, // 通常 6 分以上为合格
  calculateScore: (answers: UserAnswer[], questions: Question[]): number => {
    if (questions.length === 0) return 0;

    const correctCount = answers.filter((a) => a.isCorrect).length;
    const accuracy = correctCount / questions.length;

    // 将正确率映射到 IELTS 0-9 分制
    // 简化版本：线性映射
    const score = Math.round(accuracy * 9 * 10) / 10; // 保留一位小数

    return Math.min(9, Math.max(0, score));
  },
};
